export const GET_AGRICULTORES_RESPONSE = 'GET_AGRICULTORES_RESPONSE'
export const ADD_AGRICULTOR_RESPONSE = 'ADD_AGRICULTOR_RESPONSE'

export const GET_MOTORISTAS_RESPONSE = 'GET_MOTORISTAS_RESPONSE'
export const ADD_MOTORISTA_RESPONSE = 'ADD_MOTORISTA_RESPONSE'
export const EDIT_MOTORISTA_RESPONSE = 'EDIT_MOTORISTA_RESPONSE'

export const GET_PESAGENS_RESPONSE = 'GET_PESAGENS_RESPONSE'
export const ADD_PESAGEM_RESPONSE = 'ADD_PESAGEM_RESPONSE'
export const EDIT_PESAGEM_RESPONSE = 'EDIT_PESAGEM_RESPONSE'
export const GET_LOGRADOURO_RESPONSE = 'GET_LOGRADOURO_RESPONSE'

export const GET_CIDADE_RESPONSE = 'GET_CIDADE_RESPONSE'

export const GET_TRANSPORTADORA_RESPONSE = 'GET_TRANSPORTADORA_RESPONSE'

export const GET_VEICULO_RESPONSE = 'GET_VEICULO_RESPONSE'

export const GET_VINCULO_TRANSPORTE_RESPONSE = 'GET_VINCULO_TRANSPORTE_RESPONSE'

export const GET_FAZENDA_RESPONSE = 'GET_FAZENDA_RESPONSE'

export const GET_PRODUTO_RESPONSE = 'GET_PRODUTO_RESPONSE'

export const GET_TIPO_SERVICO_RESPONSE = 'GET_TIPO_SERVICO_RESPONSE'

export const GET_TIPO_PAGAMENTO_RESPONSE = 'GET_TIPO_PAGAMENTO_RESPONSE'

export const READER_RESPONSE = 'READER_RESPONSE'

export const READER_CODE_RESPONSE = 'CODE_RESPONSE'

export const GET_BALANCA_RESPONSE = 'GET_BALANCA_RESPONSE'

export const GET_LOGIN_RESPONSE = 'GET_LOGIN_RESPONSE'
export const LOGIN_RESPONSE = 'LOGIN_RESPONSE'
export const LOGOUT_RESPONSE = 'LOGOUT_RESPONSE'

export const API_CALL_BEGIN = 'API_CALL_BEGIN'
export const API_CALL_ERROR = 'API_CALL_ERROR'
export const API_CALL_SUCCESS = 'API_CALL_SUCCESS'